import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {loadInterestAccreditation as load, submitInterestAccreditation as submit} from 'flows/interest/accreditation/index';
import {selectInvestor} from 'flows/interest/reducer';

import InterestAccreditation from './component';

export class InterestAccreditationContainer extends React.Component {
  componentDidMount() {
    this.props.load();
  }
  render() {
    return <InterestAccreditation submit={this.props.submit} investor={this.props.investor} />
  }
}

InterestAccreditationContainer.propTypes = {
  load: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  investor: PropTypes.object.isRequired,
};

export const mapStore = store => ({
  investor: selectInvestor(store)
});

export default connect(mapStore, {load, submit})(InterestAccreditationContainer);



// WEBPACK FOOTER //
// ./web/flows/interest/accreditation/index.js